import prettyBytes from "pretty-bytes";
import { IntlShape, useIntl } from "react-intl";
import { ExpandedFormats } from "@sinch/core/hooks/format.types";

export const useFormatByteUnits = () => {
  const { formats, locale } = useIntl() as IntlShape & {
    formats: ExpandedFormats;
  };

  return (value: number, { format }: { format?: keyof ExpandedFormats["bytes"] }) => {
    const options = format ? formats.bytes[format] : {};
    const safeValue = Number.isFinite(value) ? value : 0;
    return prettyBytes(safeValue, { ...options, locale });
  };
};
